const o = {
  add_filler:
    "function add_filler(string memory rver, uint n, uint fee, string memory token, string memory args) public",
};

export default o;
